import { Binoculars } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BinocularsIcon = createLucideIcon(Binoculars);
